import { defineMessages } from "react-intl";

export const appsMessages = defineMessages({
  repository: {
    id: "f91E8b",
    defaultMessage: "Repository",
    description: "app repository",
  },
  support: {
    id: "/eTYOp",
    defaultMessage: "Support",
    description: "app support",
  },
  dataPrivacy: {
    id: "GKQGKG",
    defaultMessage: "Data privacy",
    description: "app data privacy",
  },
  appManifestUrl: {
    id: "4IgzXs",
    defaultMessage: "App Manifest URL",
    description: "label",
  },
  externalApp: {
    id: "nA2g2e",
    defaultMessage: "External app",
    description: "label",
  },
});

export const appMessages = defineMessages({
  failedToFetchAppSettings: {
    id: "ac+Y98",
    defaultMessage: "Failed to fetch app settings",
    description: "app settings error",
  },
  appActivated: {
    id: "D/+84n",
    defaultMessage: "App activated",
    description: "snackbar text",
  },
  appDeactivated: {
    id: "USO8PB",
    defaultMessage: "App deactivated",
    description: "snackbar text",
  },
});

export const appInstallationStatusMessages = defineMessages({
  pending: {
    id: "F1VtFa",
    defaultMessage: "Installation is pending...",
    description: "information",
  },
  failed: {
    id: "RY4PJY",
    defaultMessage: "Installation failed",
    description: "information",
  },
});
